import { buildMatchPath } from "pages/PageConfigs";
import { MatchContainer, ResetIdentifier } from "./styles";
import { BracketNode } from "model/Bracket/BracketGraph";
import { BracketMatchTeam } from "./BracketMatchTeam";
import { Match } from "model/Match/Match";
import { FlexColumn } from "styles/layout";
import { getNumTeams } from "model/Match/MatchTeams";
import { PlainNavLink } from "styles/elements";

interface Props {
  node: BracketNode;
  match: Match;
  tournamentId: string;
}

export const BracketMatch = ({ node, match, tournamentId }: Props) => {
  if (getNumTeams(match.teams) < 2) {
    return <></>;
  }

  const hasResetMatch = !!node.match.resetMatchId;
  return (
    <FlexColumn>
      <PlainNavLink to={buildMatchPath(match.id)}>
        <MatchContainer>
          <BracketMatchTeam
            match={match}
            node={node}
            roster={match.teams.rosters[0]}
            tournamentId={tournamentId}
            isTeamOne={true}
          />
          <BracketMatchTeam
            match={match}
            node={node}
            roster={match.teams.rosters[1]}
            tournamentId={tournamentId}
            isTeamOne={false}
          />
        </MatchContainer>
      </PlainNavLink>
      {hasResetMatch && (
        <ResetIdentifier>Bracket Reset Possible</ResetIdentifier>
      )}
    </FlexColumn>
  );
};
